<template>
  <div>
    <header-card
      :title="$t('reply.form.add-template')"
      show-back
      :route-url="{name:'owner:reply-templates'}"
    />
    <process-reply :is-template="true" />
  </div>
</template>

<script>
import ProcessReply from '@/views/owner-instagram/reply/components/ProcessReply'
import HeaderCard from '@/@bya3/components/cards/HeaderCard'

export default {
  name: 'AddReplyTemplate',
  components: { HeaderCard, ProcessReply },
}
</script>
